module.exports = __webpack_public_path__ + "img/img_3.921d6f1a.svg";